export const mapArrayKey = <T extends Record<string, any>>(array: T[], mappedKey: keyof T) => {
  return array.map((a) => a[mappedKey])
}

export const range = (start: number, end: number, length = end - start + 1) =>
  Array.from({ length }, (_, i) => start + i)
